"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reverseTransaction = void 0;
const formatDateFriendly_1 = require("../formatDateFriendly");
const uuid_1 = require("uuid");
const reverseTransaction = async (supabase, transaction_id, modified_by) => {
    // And we can run queries in the context of our authenticated user
    const { data, error } = await supabase
        .from("transactions")
        .select(`*`)
        .eq("id", transaction_id)
        .single();
    if (error)
        throw error;
    const transaction = data;
    // And we can run queries in the context of our authenticated user
    const { data: transaction_items_data, error: transactions_items_error } = await supabase
        .from("transaction_items")
        .select(`*`)
        .eq("transaction_id", transaction_id)
        .select();
    if (error)
        throw error;
    const transaction_items = transaction_items_data;
    // loop through each transaction item and update the id with a new uuid
    // reverse the direction of the transaction item
    const new_transaction_item = transaction_items.map((transaction_item) => {
        return {
            ...transaction_item,
            id: (0, uuid_1.v4)(),
            note: `Reversal of ${transaction_item.note}`,
            direction: transaction_item.direction === 1 ? -1 : 1,
            created_by: modified_by,
            created_at: new Date(),
        };
    });
    const { data: insert_transaction_reversals, error: error_insert_transaction_reversals, } = await supabase.from("transaction_items").insert(new_transaction_item);
    if (error_insert_transaction_reversals) {
        return new Response(JSON.stringify({ error: error_insert_transaction_reversals }), {
            headers: { "Content-Type": "application/json" },
            status: 400,
        });
    }
    const { error: updateTransactionError } = await supabase
        .from("transactions")
        .update({
        reversal_actioned_by: modified_by,
        reversal_date: new Date(),
        note: `${transaction.note} (Reversed on ${(0, formatDateFriendly_1.formatDateFriendly)(new Date())} `,
    })
        .eq("id", transaction_id);
    if (updateTransactionError) {
        return new Response(JSON.stringify({ error: updateTransactionError }), {
            headers: { "Content-Type": "application/json" },
            status: 400,
        });
    }
    const { data: delete_supplier_payment_outstanding, error: error_delete_supplier_payment_outstanding, } = await supabase
        .from("supplier_payment_outstanding")
        .delete()
        .in("transaction_item_id", transaction_items.map((ti) => ti.id));
    if (error_delete_supplier_payment_outstanding) {
        console.log(error_delete_supplier_payment_outstanding);
        return new Response(JSON.stringify({ error: error_delete_supplier_payment_outstanding }), {
            headers: { "Content-Type": "application/json" },
            status: 400,
        });
    }
    return transaction_items;
};
exports.reverseTransaction = reverseTransaction;
